/** @format */

import React, {useState, useEffect, useContext} from 'react';
import {Icon} from '@sttark/design-system';

// styles
import './checkout_accordion.sass';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

export const AccordionSection = ({
    sectionId,
    title,
    children,
    isEditable = false,
    className = ''
}) => {
    const ctx = useContext(CartCheckoutContext);
    const extended = ctx.currentStep === sectionId;
    const completed = ctx.currentStep > sectionId;
    const active = ctx.currentStep === sectionId;

    return (
        <div className={`container_tab billing ${className}`}>
            <div
                className={`tab-title m-0 d-flex align-items-center justify-content-start border-bottom ${
                    active ? 'tab_active' : 'tab_inactive'
                }`}>
                {completed && (
                    <span className="tab_icon d-flex align-items-center justify-content-center flex-shrink-0">
                        <Icon name="check" color="#00892f" large />
                    </span>
                )}
                <div>
                    <h3 className={`${completed ? 'is-completed' : 'm-0'}`}>{title}</h3>
                    {completed && isEditable && (
                        <button onClick={() => ctx.onSetCurrentStep(sectionId)}>
                            <h5 className="color-action-primary">View & Edit</h5>
                        </button>
                    )}
                </div>

                {/* if tab is completed show summary next to title */}
                {completed && <div className="m-0">{children}</div>}
            </div>

            {/* if the tab is being edited render this*/}
            {extended && children && active && (
                <div className="tab_content border-bottom">{children}</div>
            )}
        </div>
    );
};

export const CheckoutAccordion = ({children}) => {
    return <section className="accordion-container border-all border-bottom-0">{children}</section>;
};
